module.exports = __webpack_public_path__ + "img/upload.bc9503a1.png";